import errorPic from '/images/error.jpeg'

import Button from '@/components/Button'
import { Layout } from '@/components/layout'

import classes from './styles.module.css'

export function ErrorFallback() {
  return (
    <Layout wrapClassName={classes.root}>
      <div className={classes.container}>
        <img src={errorPic} alt="Error" className={classes.image} />
        <p className={classes.text}>Что-то пошло не так</p>
        <Button variant="primaryRed" onClick={() => window.location.reload()}>
          Попробовать ещё раз
        </Button>
      </div>
    </Layout>
  )
}
